export const SET_NOTIFICATION = 'SET_NOTIFICATION'
export const ClEAR_NOTIFICATION = 'ClEAR_NOTIFICATION'
export const SET_SUPPORTER_ONBOARDING_ACTIVE_STEP_INDEX = 'SET_SUPPORTER_ONBOARDING_ACTIVE_STEP_INDEX'
export const SET_BACKDROP_LOADING = 'SET_BACKDROP_LOADING'

// export const setNotification = (notificationType, message, options = {}) => ({
export const setNotification = (notificationType, message, options = {duration: 6000}) => ({
  type: SET_NOTIFICATION,
  notificationType,
  message,
  ...options
})

export const setBackdropLoading = (isLoading) => ({
  type: SET_BACKDROP_LOADING,
  backdropLoading: isLoading
})

export const clearNotification = () => ({
  type: ClEAR_NOTIFICATION
})

export const updateSupporterOnboardingActiveStepIndex = (activeStep) => (
  { type: SET_SUPPORTER_ONBOARDING_ACTIVE_STEP_INDEX, activeStep }
)
